/**
 * @sw-package b2b
 */
const PluginManager = window.PluginManager;

PluginManager.register('B2bShoppingListModal', () => import('./plugin/shopping-list/shopping-list-modal.plugin'), '[data-b2b-shopping-list-modal]');
PluginManager.register('B2bShoppingListAddToCart', () => import('./plugin/shopping-list/shopping-list-add-to-cart.plugin'), '[data-b2b-shopping-list-add-to-cart]');
PluginManager.register('B2bShoppingListItem', () => import('./plugin/shopping-list/shopping-list-item.plugin'), '[data-b2b-shopping-list-item]');
PluginManager.register('B2bShoppingListContent', () => import('./plugin/shopping-list/shopping-list-content.plugin'), '[data-b2b-shopping-list-content]');
PluginManager.register('B2bDropdownListItems', () => import('./plugin/shopping-list/shopping-list-dropdown.plugin'), '[data-b2b-dropdown-list-items]');
PluginManager.register('B2bFetchDropdownListItems', () => import('./plugin/shopping-list/shopping-list-fetch-dropdown.plugin'), '[data-b2b-fetch-dropdown-list-items]');
PluginManager.register('B2bShoppingListDelegation', () => import('./plugin/shopping-list/shopping-list-delegation.plugin'), '[data-b2b-shopping-list-delegation]');

if (!!PluginManager.getPlugin('B2bQuickOrderList')) {
    PluginManager.override('B2bQuickOrderList', () => import('./plugin/quick-order/listing.plugin'), '[data-b2b-quick-order-list]');
}

